/* Catálogo generado desde el Excel de matrices de gravedad. */
export type DamageLocation = {
  id: string;
  family: string;
  parent: string;
  label: string;
  /** Categoría del daño en ese elemento (1-4). */
  category: 1 | 2 | 3 | 4;
};

export type RoadDamageType = {
  id: string;
  name: string;
  group: string;
  subtype: string;
  unit: string | null;
  locations: DamageLocation[];
};

export const DAMAGE_GROUPS: string[] = [
  "Deformaciones",
  "Roturas",
  "Exudaciones",
  "Otros"
];

const RAW_ROAD_DAMAGES: RoadDamageType[] = [
  {
    "id": "d8",
    "name": "Deformaciones. Roderas",
    "group": "Deformaciones",
    "subtype": "Roderas",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 3
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 3
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 3
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d9",
    "name": "Deformaciones. Hundimiento",
    "group": "Deformaciones",
    "subtype": "Hundimiento",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 2
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 2
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 2
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 4
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 4
      }
    ]
  },
  {
    "id": "d10",
    "name": "Deformaciones. Cordón longitudinal",
    "group": "Deformaciones",
    "subtype": "Cordón longitudinal",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d11",
    "name": "Deformaciones. Arrollamiento transversal",
    "group": "Deformaciones",
    "subtype": "Arrollamiento transversal",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d12",
    "name": "Deformaciones. Firme ondulado",
    "group": "Deformaciones",
    "subtype": "Firme ondulado",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d13",
    "name": "Deformaciones. Ondulación",
    "group": "Deformaciones",
    "subtype": "Ondulación",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d14",
    "name": "Deformaciones. Blandón",
    "group": "Deformaciones",
    "subtype": "Blandón",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 4
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 4
      }
    ]
  },
  {
    "id": "d15",
    "name": "Deformaciones. Huella",
    "group": "Deformaciones",
    "subtype": "Huella",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d16",
    "name": "Deformaciones. Burbuja",
    "group": "Deformaciones",
    "subtype": "Burbuja",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d17",
    "name": "Deformaciones. Protuberancia",
    "group": "Deformaciones",
    "subtype": "Protuberancia",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d18",
    "name": "Deformaciones. Escalonamientos",
    "group": "Deformaciones",
    "subtype": "Escalonamientos",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d19",
    "name": "Deformaciones. Asientos",
    "group": "Deformaciones",
    "subtype": "Asientos",
    "unit": "cm/m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 4
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 4
      }
    ]
  },
  {
    "id": "d20",
    "name": "Roturas. Grieta longitudinal",
    "group": "Roturas",
    "subtype": "Grieta longitudinal",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d21",
    "name": "Roturas. Bache",
    "group": "Roturas",
    "subtype": "Bache",
    "unit": "m3",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 4
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 4
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 3
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 3
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 2
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 4
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 4
      }
    ]
  },
  {
    "id": "d22",
    "name": "Roturas. Grieta transversal",
    "group": "Roturas",
    "subtype": "Grieta transversal",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d23",
    "name": "Roturas. Grieta errática",
    "group": "Roturas",
    "subtype": "Grieta errática",
    "unit": "cm/m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d24",
    "name": "Roturas. Grieta parabólica",
    "group": "Roturas",
    "subtype": "Grieta parabólica",
    "unit": "cm/m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d25",
    "name": "Roturas. Cuarteo en malla",
    "group": "Roturas",
    "subtype": "Cuarteo en malla",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d26",
    "name": "Roturas. Grietas en las rodadas",
    "group": "Roturas",
    "subtype": "Grietas en las rodadas",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d27",
    "name": "Roturas. Grieta en el borde",
    "group": "Roturas",
    "subtype": "Grieta en el borde",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d28",
    "name": "Roturas. Grieta reflejada",
    "group": "Roturas",
    "subtype": "Grieta reflejada",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d29",
    "name": "Roturas. Grieta curva",
    "group": "Roturas",
    "subtype": "Grieta curva",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d30",
    "name": "Roturas. Fisuras finas",
    "group": "Roturas",
    "subtype": "Fisuras finas",
    "unit": "m",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 1
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 1
      }
    ]
  },
  {
    "id": "d31",
    "name": "Roturas. Descascarillado",
    "group": "Roturas",
    "subtype": "Descascarillado",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d32",
    "name": "Exudaciones. Flujo de ligante",
    "group": "Exudaciones",
    "subtype": "Flujo de ligante",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d33",
    "name": "Exudaciones. Ascensión de finos",
    "group": "Exudaciones",
    "subtype": "Ascensión de finos",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      }
    ]
  },
  {
    "id": "d34",
    "name": "Fluencias",
    "group": "Otros",
    "subtype": "Fluencias",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 3
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 3
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 3
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 3
      }
    ]
  },
  {
    "id": "d35",
    "name": "Desgaste",
    "group": "Otros",
    "subtype": "Desgaste",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 2
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 2
      },
      {
        "id": "c10",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.1 HORIZONTAL",
        "label": "2.1 HORIZONTAL",
        "category": 2
      },
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 2
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 2
      },
      {
        "id": "c27",
        "family": "6 APARTADEROS",
        "parent": "6.1 Zona de parada de emergencia",
        "label": "6.1 Zona de parada de emergencia",
        "category": 1
      },
      {
        "id": "c28",
        "family": "6 APARTADEROS",
        "parent": "6.2 Zona de inspección de vehículos",
        "label": "6.2 Zona de inspección de vehículos",
        "category": 1
      },
      {
        "id": "c29",
        "family": "6 APARTADEROS",
        "parent": "6.3 Zona de conservación",
        "label": "6.3 Zona de conservación",
        "category": 1
      },
      {
        "id": "c40",
        "family": "9 TÚNELES",
        "parent": "Calzada interior",
        "label": "Calzada interior",
        "category": 2
      },
      {
        "id": "c45",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.1 Calzada",
        "label": "10.1 Calzada",
        "category": 2
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 2
      }
    ]
  },
  {
    "id": "d36",
    "name": "Desplazamiento",
    "group": "Otros",
    "subtype": "Desplazamiento",
    "unit": "m",
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      },
      {
        "id": "c25",
        "family": "5 TALUDES",
        "parent": "5.3 Revestimientos",
        "label": "5.3 Revestimientos",
        "category": 3
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 4
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 3
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 3
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 3
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 3
      }
    ]
  },
  {
    "id": "d37",
    "name": "Desalineación",
    "group": "Otros",
    "subtype": "Desalineación",
    "unit": "m",
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 3
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 3
      },
      {
        "id": "c25",
        "family": "5 TALUDES",
        "parent": "5.3 Revestimientos",
        "label": "5.3 Revestimientos",
        "category": 3
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 4
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 3
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 3
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 3
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 3
      }
    ]
  },
  {
    "id": "d38",
    "name": "Falta de reflectancia",
    "group": "Otros",
    "subtype": "Falta de reflectancia",
    "unit": null,
    "locations": [
      {
        "id": "c10",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.1 HORIZONTAL",
        "label": "2.1 HORIZONTAL",
        "category": 3
      },
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 3
      },
      {
        "id": "c13",
        "family": "3 BALIZAMIENTO",
        "parent": "3.1 Hitos de arista",
        "label": "3.1 Hitos de arista",
        "category": 3
      },
      {
        "id": "c14",
        "family": "3 BALIZAMIENTO",
        "parent": "3.2 Captafaros",
        "label": "3.2 Captafaros",
        "category": 3
      },
      {
        "id": "c16",
        "family": "3 BALIZAMIENTO",
        "parent": "3.4 Balizas flexibles",
        "label": "3.4 Balizas flexibles",
        "category": 3
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 3
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 2
      }
    ]
  },
  {
    "id": "d39",
    "name": "Fallo eléctrico",
    "group": "Otros",
    "subtype": "Fallo eléctrico",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      }
    ]
  },
  {
    "id": "d40",
    "name": "Pantalla dañada",
    "group": "Otros",
    "subtype": "Pantalla dañada",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      }
    ]
  },
  {
    "id": "d41",
    "name": "Información incorrecta",
    "group": "Otros",
    "subtype": "Información incorrecta",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 4
      }
    ]
  },
  {
    "id": "d42",
    "name": "Rotura",
    "group": "Otros",
    "subtype": "Rotura",
    "unit": null,
    "locations": [
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 3
      },
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      },
      {
        "id": "c13",
        "family": "3 BALIZAMIENTO",
        "parent": "3.1 Hitos de arista",
        "label": "3.1 Hitos de arista",
        "category": 2
      },
      {
        "id": "c14",
        "family": "3 BALIZAMIENTO",
        "parent": "3.2 Captafaros",
        "label": "3.2 Captafaros",
        "category": 1
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 2
      },
      {
        "id": "c16",
        "family": "3 BALIZAMIENTO",
        "parent": "3.4 Balizas flexibles",
        "label": "3.4 Balizas flexibles",
        "category": 2
      },
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      },
      {
        "id": "c25",
        "family": "5 TALUDES",
        "parent": "5.3 Revestimientos",
        "label": "5.3 Revestimientos",
        "category": 4
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 4
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 2
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 4
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 4
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 4
      },
      {
        "id": "c52",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.4 Redes de protección",
        "label": "10.4 Redes de protección",
        "category": 3
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 4
      }
    ]
  },
  {
    "id": "d43",
    "name": "Suciedad",
    "group": "Otros",
    "subtype": "Suciedad",
    "unit": null,
    "locations": [
      {
        "id": "c10",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.1 HORIZONTAL",
        "label": "2.1 HORIZONTAL",
        "category": 1
      },
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 1
      },
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 2
      },
      {
        "id": "c13",
        "family": "3 BALIZAMIENTO",
        "parent": "3.1 Hitos de arista",
        "label": "3.1 Hitos de arista",
        "category": 1
      },
      {
        "id": "c14",
        "family": "3 BALIZAMIENTO",
        "parent": "3.2 Captafaros",
        "label": "3.2 Captafaros",
        "category": 1
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 1
      },
      {
        "id": "c16",
        "family": "3 BALIZAMIENTO",
        "parent": "3.4 Balizas flexibles",
        "label": "3.4 Balizas flexibles",
        "category": 1
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 1
      }
    ]
  },
  {
    "id": "d44",
    "name": "Desprendimiento",
    "group": "Otros",
    "subtype": "Desprendimiento",
    "unit": null,
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 3
      },
      {
        "id": "c25",
        "family": "5 TALUDES",
        "parent": "5.3 Revestimientos",
        "label": "5.3 Revestimientos",
        "category": 4
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 4
      }
    ]
  },
  {
    "id": "d45",
    "name": "Deformación por impacto",
    "group": "Otros",
    "subtype": "Deformación por impacto",
    "unit": null,
    "locations": [
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 2
      },
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 2
      },
      {
        "id": "c13",
        "family": "3 BALIZAMIENTO",
        "parent": "3.1 Hitos de arista",
        "label": "3.1 Hitos de arista",
        "category": 1
      },
      {
        "id": "c14",
        "family": "3 BALIZAMIENTO",
        "parent": "3.2 Captafaros",
        "label": "3.2 Captafaros",
        "category": 1
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 2
      },
      {
        "id": "c16",
        "family": "3 BALIZAMIENTO",
        "parent": "3.4 Balizas flexibles",
        "label": "3.4 Balizas flexibles",
        "category": 3
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 2
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 2
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 2
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 2
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 2
      }
    ]
  },
  {
    "id": "d46",
    "name": "Erosión",
    "group": "Otros",
    "subtype": "Erosión",
    "unit": "m2",
    "locations": [
      {
        "id": "c10",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.1 HORIZONTAL",
        "label": "2.1 HORIZONTAL",
        "category": 2
      },
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 2
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 3
      }
    ]
  },
  {
    "id": "d47",
    "name": "Colapso",
    "group": "Otros",
    "subtype": "Colapso",
    "unit": "m3",
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 4
      }
    ]
  },
  {
    "id": "d48",
    "name": "Rejilla rota",
    "group": "Otros",
    "subtype": "Rejilla rota",
    "unit": "ud",
    "locations": []
  },
  {
    "id": "d49",
    "name": "Sedimentación",
    "group": "Otros",
    "subtype": "Sedimentación",
    "unit": "m2",
    "locations": []
  },
  {
    "id": "d50",
    "name": "Tapa rota",
    "group": "Otros",
    "subtype": "Tapa rota",
    "unit": "ud",
    "locations": []
  },
  {
    "id": "d51",
    "name": "Infiltraciones/mancha humedad",
    "group": "Otros",
    "subtype": "Infiltraciones/mancha humedad",
    "unit": "l/s",
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 2
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 2
      }
    ]
  },
  {
    "id": "d52",
    "name": "Colapso estructural",
    "group": "Otros",
    "subtype": "Colapso estructural",
    "unit": "m3",
    "locations": []
  },
  {
    "id": "d53",
    "name": "Inundación",
    "group": "Otros",
    "subtype": "Inundación",
    "unit": "m2",
    "locations": []
  },
  {
    "id": "d54",
    "name": "Inestabilidad",
    "group": "Otros",
    "subtype": "Inestabilidad",
    "unit": null,
    "locations": [
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 1
      },
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      },
      {
        "id": "c13",
        "family": "3 BALIZAMIENTO",
        "parent": "3.1 Hitos de arista",
        "label": "3.1 Hitos de arista",
        "category": 1
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 2
      },
      {
        "id": "c16",
        "family": "3 BALIZAMIENTO",
        "parent": "3.4 Balizas flexibles",
        "label": "3.4 Balizas flexibles",
        "category": 2
      },
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 1
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 2
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 2
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 2
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 2
      }
    ]
  },
  {
    "id": "d55",
    "name": "Asentamientos",
    "group": "Otros",
    "subtype": "Asentamientos",
    "unit": null,
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      }
    ]
  },
  {
    "id": "d56",
    "name": "Deslizamientos",
    "group": "Otros",
    "subtype": "Deslizamientos",
    "unit": null,
    "locations": [
      {
        "id": "c23",
        "family": "5 TALUDES",
        "parent": "5.1 Talud desmonte",
        "label": "5.1 Talud desmonte",
        "category": 4
      },
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      }
    ]
  },
  {
    "id": "d57",
    "name": "Rotura de malla",
    "group": "Otros",
    "subtype": "Rotura de malla",
    "unit": null,
    "locations": []
  },
  {
    "id": "d58",
    "name": "Escollera desplazada",
    "group": "Otros",
    "subtype": "Escollera desplazada",
    "unit": "m",
    "locations": [
      {
        "id": "c24",
        "family": "5 TALUDES",
        "parent": "5.2 Talud de terraplén",
        "label": "5.2 Talud de terraplén",
        "category": 4
      }
    ]
  },
  {
    "id": "d59",
    "name": "Fallo de anclajes",
    "group": "Otros",
    "subtype": "Fallo de anclajes",
    "unit": "ud",
    "locations": [
      {
        "id": "c25",
        "family": "5 TALUDES",
        "parent": "5.3 Revestimientos",
        "label": "5.3 Revestimientos",
        "category": 1
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 3
      }
    ]
  },
  {
    "id": "d60",
    "name": "Corrosión",
    "group": "Otros",
    "subtype": "Corrosión",
    "unit": "m2",
    "locations": [
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 1
      },
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 1
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 1
      },
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 1
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 1
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 1
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 1
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 1
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 1
      }
    ]
  },
  {
    "id": "d61",
    "name": "Vegetación",
    "group": "Otros",
    "subtype": "Vegetación",
    "unit": "m2",
    "locations": [
      {
        "id": "c4",
        "family": "",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c5",
        "family": "1 CALZADA",
        "parent": "1.1 CARRIL",
        "label": "1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c10",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.1 HORIZONTAL",
        "label": "2.1 HORIZONTAL",
        "category": 1
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 1
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 1
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 1
      }
    ]
  },
  {
    "id": "d62",
    "name": "Residuos",
    "group": "Otros",
    "subtype": "Residuos",
    "unit": "m3",
    "locations": [
      {
        "id": "c6",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c7",
        "family": "1 CALZADA",
        "parent": "1.2 ARCÉN",
        "label": "1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      },
      {
        "id": "c8",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS",
        "category": 1
      },
      {
        "id": "c9",
        "family": "1 CALZADA",
        "parent": "1.3 BERMA",
        "label": "1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN",
        "category": 1
      }
    ]
  },
  {
    "id": "d63",
    "name": "Oxidación",
    "group": "Otros",
    "subtype": "Oxidación",
    "unit": "m2",
    "locations": [
      {
        "id": "c11",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VERTICAL",
        "label": "2.2 VERTICAL",
        "category": 1
      },
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 1
      },
      {
        "id": "c15",
        "family": "3 BALIZAMIENTO",
        "parent": "3.3 Paneles direccionales",
        "label": "3.3 Paneles direccionales",
        "category": 1
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 1
      },
      {
        "id": "c49",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "11.1 Barreras metálicas",
        "label": "11.1 Barreras metálicas",
        "category": 1
      },
      {
        "id": "c50",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.2 Pretiles",
        "label": "10.2 Pretiles",
        "category": 1
      },
      {
        "id": "c51",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.3 Amortiguadores de impacto",
        "label": "10.3 Amortiguadores de impacto",
        "category": 1
      },
      {
        "id": "c53",
        "family": "11 ELEMENTOS DE SEGURIDAD",
        "parent": "10.5 Sistemas de contención",
        "label": "10.5 Sistemas de contención",
        "category": 1
      }
    ]
  },
  {
    "id": "d64",
    "name": "Lámpara rota",
    "group": "Otros",
    "subtype": "Lámpara rota",
    "unit": "ud",
    "locations": []
  },
  {
    "id": "d65",
    "name": "Puerta rota",
    "group": "Otros",
    "subtype": "Puerta rota",
    "unit": "ud",
    "locations": []
  },
  {
    "id": "d66",
    "name": "Fallo de sensores",
    "group": "Otros",
    "subtype": "Fallo de sensores",
    "unit": "ud",
    "locations": [
      {
        "id": "c26",
        "family": "5 TALUDES",
        "parent": "5.4 Sistemas de estabilización",
        "label": "5.4 Sistemas de estabilización",
        "category": 4
      }
    ]
  },
  {
    "id": "d67",
    "name": "Desconfiguración",
    "group": "Otros",
    "subtype": "Desconfiguración",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      }
    ]
  },
  {
    "id": "d68",
    "name": "iluminación insuficiente",
    "group": "Otros",
    "subtype": "iluminación insuficiente",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 1
      },
      {
        "id": "c46",
        "family": "10 VIAS DE SERVICIO",
        "parent": "10.2 Señalización",
        "label": "10.2 Señalización",
        "category": 2
      }
    ]
  },
  {
    "id": "d69",
    "name": "Fallo de juntas",
    "group": "Otros",
    "subtype": "Fallo de juntas",
    "unit": null,
    "locations": []
  },
  {
    "id": "d70",
    "name": "Falta de estanqueidad",
    "group": "Otros",
    "subtype": "Falta de estanqueidad",
    "unit": null,
    "locations": []
  },
  {
    "id": "d71",
    "name": "Fallo de ventiladores",
    "group": "Otros",
    "subtype": "Fallo de ventiladores",
    "unit": null,
    "locations": [
      {
        "id": "c41",
        "family": "9 TÚNELES",
        "parent": "Instalaciones de ventilación",
        "label": "Instalaciones de ventilación",
        "category": 2
      }
    ]
  },
  {
    "id": "d72",
    "name": "Fallo de señalización",
    "group": "Otros",
    "subtype": "Fallo de señalización",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      }
    ]
  },
  {
    "id": "d73",
    "name": "Fallo de Comunicación",
    "group": "Otros",
    "subtype": "Fallo de Comunicación",
    "unit": null,
    "locations": [
      {
        "id": "c12",
        "family": "2 SEÑALIZACIÓN",
        "parent": "2.2 VARIABLE",
        "label": "2.2 VARIABLE",
        "category": 3
      }
    ]
  },
  {
    "id": "d74",
    "name": "Fallo mecánico",
    "group": "Otros",
    "subtype": "Fallo mecánico",
    "unit": null,
    "locations": []
  },
  {
    "id": "d75",
    "name": "Fallo estructural",
    "group": "Otros",
    "subtype": "Fallo estructural",
    "unit": null,
    "locations": []
  }
];

/** Solo daños con al menos un valor en la matriz; "Rotura" genérica se excluye. */
export const ROAD_DAMAGES: RoadDamageType[] = RAW_ROAD_DAMAGES.filter(
  (damage) => damage.locations.length > 0 && damage.name.trim() !== 'Rotura'
);

/** Gravedad N1-N4 a partir de categoría del elemento e intensidad 1-4. */
export function severityFrom(category: number, intensity: number): 'N1' | 'N2' | 'N3' | 'N4' {
  const c = Math.min(4, Math.max(1, category));
  const i = Math.min(4, Math.max(1, intensity));
  if (c === 1) return 'N1';
  if (c === 2) return i === 1 ? 'N1' : 'N2';
  if (c === 3) return i === 1 ? 'N1' : i === 2 ? 'N2' : 'N3';
  return (['N1', 'N2', 'N3', 'N4'] as const)[i - 1];
}
